<app-banner [heading]="'PHOTO GALLERY'" [detail]="'Everyday is a celebration at Tagore Global School - Kurukshetra.'" *ngIf="showList"></app-banner>

<section class="events3" *ngIf="showList">
  <div class="container" >

    <div class="row d-flex justify-content-between">

   <div class="col-md-4  d-flex align-items-stretch" *ngFor="let image of filterImage;">
        <div class="card mx-auto mx-md-2  ">
          <div class="card-img">
            <img [src]="image.imgUrl" class="img-fluid" [alt]="image.caption">
          </div>
          <div class="card-body" [routerLink]="['/gallery',image.$key]" (click)="hideList()">
            <h5 class="card-title"> {{image.caption}} </h5>
            <h5 class="card-title"> {{image.date}} </h5>
          </div>
        </div>
    </div>
   
    
</div>
  </div>
</section>
<div  *ngIf="!showList">
  <router-outlet></router-outlet>
</div>